export default __webpack_public_path__ + "static/media/Group 15530.26c3e9d2.svg";